import { loadScript } from "./loadScript";

const MATHJAX_BASE = "https://cdn.jsdelivr.net/npm/mathjax@3/es5/tex-svg.js";

window.__rendering = window.__rendering || {};

window.__rendering.mathJax = {
  ready: false,
  loading: false,

  load: async () => {
    const api = window.__rendering!.mathJax!;

    if (api.ready || api.loading) return;
    api.loading = true;

    // MathJax config - must be set before loading the script.
    window.MathJax = {
      tex: {
        inlineMath: [],
        displayMath: [
          ["$$", "$$"],
          [String.raw`\[`, String.raw`\]`]
        ]
      },
      output: {
        displayAlign: "center",
        displayIndent: "0"
      },
      svg: {
        fontCache: "global",
        scale: 1,
        minScale: 0.5,
        exFactor: 0.5
      },
      startup: {
        typeset: false
      },
      options: {
        skipHtmlTags: ["script", "noscript", "style", "textarea", "pre"],
        processHtmlClass: "math",
        ignoreHtmlClass: ".*"
      }
    };

    await loadScript(MATHJAX_BASE);

    api.ready = true;
    api.loading = false;
  },

  render: (container: HTMLElement | string) => {
    const api = window.__rendering!.mathJax!;

    if (!api.ready || !window.MathJax?.typesetPromise) return;

    const el =
      typeof container === "string"
        ? document.getElementById(container)
        : container;

    if (!el) return;

    requestAnimationFrame(() => {
      setTimeout(() => {
        if (window.MathJax?.typesetPromise) {
          window.MathJax.typesetPromise([el]).catch(err =>
            console.error("MathJax typeset error:", err)
          );
        }
      }, 0);
    });
  }
};
